import React, { Component } from 'react';

/**
 * Copy component - Utility component for array generation
 * Demonstrates array creation and manipulation in React
 */
class Copy extends Component {
    constructor(props) {
        super(props);
        this.state = {
            total: []
        };
    }

    /**
     * Creates an array of numbers within a specified range
     * @param {number} start - Starting number (default: 100)
     * @param {number} end - Ending number (default: 200)
     * @param {number} increment - Increment value (default: 5)
     */
    createArray = (start = 100, end = 200, increment = 5) => {
        const total = [];
        for (let i = start; i < end; i += increment) {
            total.push(i);
        }
        this.setState({ total });
    }

    componentDidMount() {
        this.createArray();
    }

    render() {
        // const { total } = this.state;

        return (
            <div className="copy-component">
                {/* This component generates an array in the background */}
                {/* Array length: {this.state.total.length} items */}
                {/* Uncomment below to display the array */}
                {/* 
                <div className="array-display">
                    <h3>Generated Array ({this.state.total.length} items):</h3>
                    <p>{this.state.total.join(', ')}</p>
                </div>
                */}
            </div>
        );
    }
}

export default Copy;
